import React from 'react';
import { Space as AntSpace } from 'antd';

type AntSpaceProps = React.ComponentProps<typeof AntSpace>;

const Space = React.forwardRef<HTMLDivElement, AntSpaceProps>((props, ref) => (
  <span ref={ref}>
    <AntSpace {...props} />
  </span>
));

Space.displayName = 'Space';

export default Space;
